import React, {useEffect, useState} from 'react';
import {Button} from "primereact/button";
import {types, useSidebar} from "./SidebarContext";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {Divider} from "primereact/divider";
import {Avatar} from "primereact/avatar";
import {Tag} from "primereact/tag";
import Config from "./config";
import './index.css';
import * as Icons from "./icons";
import axios from "axios";


function SidebarItem({title, className, icon, image, active, onClick, tag}){
    const location = useLocation();
    return(
        <div className={`flex align-items-center p-2 justify-content-between border-round-lg text-gray-500 ${onClick && 'cursor-pointer'} ${ active && 'bg-primary-100 text-black-alpha-90 font-bold'} `}  onClick={onClick}>
            <div className="flex align-items-center  gap-2">
                {icon && (<Avatar className="bg-transparent" icon={icon}/>)}
                {image && (<Avatar image={image} className="avatar-sm"/>)}
                <div className={className ? className :'text-sm'}>{title}</div>
            </div>
            {tag && (<Tag severity={"danger"} className="flex align-items-center justify-content-center" style={{width:'1.5rem',height:"1.5rem"}} rounded>{tag}</Tag>)}
        </div>);
}

function Sidebar() {
    let sidebar = useSidebar();
    const navigate = useNavigate();

    useEffect(()=>{
        document.title = `${Config.glossary.siteName} - ${Config.glossary && Config.glossary[sidebar.getSelectedItem().title]? Config.glossary[sidebar.getSelectedItem().title].title: sidebar.getSelectedItem().title}`;
    },[sidebar.state.selectedItem]);

    return (
        <div className="w-full h-full">
            <div className={`flex flex-column justify-content-between p-2 h-full`}>
                <div className="flex flex-column gap-2">
                    <div className="flex flex-column p-1">
                        <span className="yekan-bakh-font text-2xl text-primary">{Config.glossary.siteName}</span>
                        <span className="text-gray-500">{Config.glossary.siteDescription}</span>
                    </div>
                    <Divider className="m-0"/>
                    {
                        sidebar.state.items.map((item)=>(<SidebarItem key={item.id} title={Config.glossary[item.title] ? Config.glossary[item.title].title:item.title} active={sidebar.state.selectedItem===item.id} tag={item.tag} icon={item.icon(sidebar.state.selectedItem===item.id)} onClick={()=>{navigate(item.path); sidebar.dispatch({type:types.SET_SELECTED, selectedItem:item.id})}}/>))
                    }
                </div>
                <div className="flex flex-column align-items-center">
                    {/*<Avatar size="xlarge" image={`${process.env.PUBLIC_URL}/assets/images/logo.svg`}/>*/}
                    {/*<div className="flex gap-2">*/}
                    {/*    <Avatar image={`${process.env.PUBLIC_URL}/assets/icons/great-britain-48.png`} onClick={()=>{general.switchLanguage("en", general.dispatch)}}/>*/}
                    {/*    <Avatar image={`${process.env.PUBLIC_URL}/assets/icons/iran-48.png`} onClick={()=>{general.switchLanguage("fa", general.dispatch)}}/>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;